// ---------------------------------------------------------------------------
// Icones du lecteur.
//
// Toji (23/10) : « des icônes dédiées partout, pas des SVG refaits à la main ».
// Le jeu est Lucide (lucide.dev, licence ISC) — le même que les versions /v/x/
// (`versions/coeur/icones.js`) : une grille de 24, un trait. Les masses pleines
// (lecture, pause, épisodes) portent la classe `plein` : remplies ET tracées,
// pour que leurs barres (SkipBack, SkipForward) restent visibles.
// ---------------------------------------------------------------------------
import {
  ChevronLeft, Play, Pause, SkipBack, SkipForward, Volume2, Volume1, VolumeX,
  Captions, AudioLines, Maximize, Minimize, ListVideo, PictureInPicture2,
} from 'lucide';

const svg = ([, , enfants = []], plein = false) =>
  `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"${plein ? ' class="plein"' : ''}>${
    enfants.map(([tag, a]) => `<${tag} ${Object.entries(a).map(([k, v]) => `${k}="${v}"`).join(' ')}/>`).join('')}</svg>`;

export const ICONES = {
  retour: svg(ChevronLeft),
  lecture: svg(Play, true),
  pause: svg(Pause, true),
  precedent: svg(SkipBack, true),
  suivant: svg(SkipForward, true),
  sonFort: svg(Volume2),
  sonFaible: svg(Volume1),
  sonCoupe: svg(VolumeX),
  soustitres: svg(Captions),
  audio: svg(AudioLines),
  plein: svg(Maximize),
  reduire: svg(Minimize),
  sources: svg(ListVideo),
  detacher: svg(PictureInPicture2),
};

/** Les boutons du lecteur et l'icône qu'ils portent au repos (le HTML n'en dessine plus). */
export const ICONES_DES_BOUTONS = {
  'l-central': 'lecture', 'l-amorce': 'lecture', 'l-son-coupe': 'sonCoupe', 'retour2': 'retour',
  'l-prec': 'precedent', 'l-play': 'lecture', 'l-suiv': 'suivant', 'l-audio': 'audio', 'l-st': 'soustitres',
  'l-sources': 'sources', 'l-detacher': 'detacher', 'l-plein': 'plein',
};
